export default __webpack_public_path__ + "static/media/36-min.d1ca1b77.jpg";